var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip-wrapper non-editable green",attrs:{"contenteditable":"false"}},[_c('span',{staticClass:"no-visible"},[_vm._v(" %%"+_vm._s(_vm.value)+"- ")]),_c('span',[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('span',{staticClass:"no-visible"},[_vm._v(" %% ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }